<!-- 资讯和公告 -->
<template>
  <div class="notice-and-news">
    <!-- 顶部 -->
    <div class="top-header row">
      <tab-list-header :list="tabList" :cur-index="curIndex"
        :list-style="{ justifyContent: 'flex-start' }"
        :item-style="{ marginRight: '16px' }"
        :cur-item-style="{ fontWeight: 700 }"
        @clickTab="(index) => { this.curIndex = index }"/>
      <div class="more row" @click="clickMore">
        <div>更多</div>
        <img :src="RIGHT_ARROW" class="arrow"/>
      </div>
    </div>
    <!-- 列表 -->
    <div
      v-for="(item, index) in dataList"
      :key="index"
      class="item"
      @click="goNewsDetail(item, curIndex)"
    >
      <div class="title">{{item.title}}</div>
      <div class="subtitle">{{item.subTitle}}</div>
    </div>
    <div v-if="$isEmpty(dataList)" class="empty">{{emptyText}}</div>
  </div>
</template>

<script>
import TabListHeader from '@/components/chart/TabListHeader.vue';
import tool from '@/utils/tool';

export default {
  name: 'notice-and-news',

  components: {
    TabListHeader,
  },

  props: {
    fundCode: {
      type: String,
      default: '',
    },
    fundName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      curIndex: 0,
      tabList: [{ tabName: '公告' }, { tabName: '资讯' }],
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
      noticeList: [],
      newsList: [],
    };
  },

  computed: {
    dataList() {
      return [this.noticeList, this.newsList][this.curIndex] || [];
    },
    emptyText() {
      return `暂无${['公告', '资讯'][this.curIndex]}数据`;
    },
  },

  mounted() {
    this.$http.useRequests('EMAnoticeApi.getNoticeList', this.fundCode)
      .then((res) => {
        console.log('get notice list', res);
        this.noticeList = res?.noticeList || [];
      })
      .catch((err) => { console.log('getNoticeList ERR', err); });
    this.$http.useRequests('EMNewApi.getNewsList', this.fundCode)
      .then((res) => {
        console.log('get news list', res);
        this.newsList = res?.newsList || [];
      })
      .catch((err) => { console.log('getNewsList ERR', err); });
  },

  methods: {
    clickMore() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.gdgg.click', '');
      this.$goFundApp();
    },
    goNewsDetail(item, index) {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.tz.click', '');
      const code = item.articleCode || item.newsCode;
      // 跳转区分微信环境
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        const source = `fund://mp.1234567.com.cn/weex/fund4a491d52ab4a42/pages/annDetail/index?artCode=${code}&fundCode=${this.fundCode}&fundName=${this.fundName}`;
        const convertUrl = tool.getJumpUrl(source);
        if (!index) {
          if (source === convertUrl) {
            this.$goFundApp();
            return;
          }
          wx.miniProgram.navigateTo({
            url: convertUrl,
          });
          return;
        }
        wx.miniProgram.navigateTo({
          url: `/pages/news/newsDetail?code=${code}&type=100`,
        });
      } else {
        multi.$router.push({
          type: 1,
          url: `https://h5.1234567.com.cn/app/news?code=${code}&type=100`,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.notice-and-news {
  width: 100%;
  background-color: #ffffff;
  margin-top: 24px;
  box-sizing: border-box;
  padding: 40px 24px;
  border-radius: 12px;
  .top-header {
    justify-content: space-between;
    .more {
      font-size: 28px;
      color: #666666;
      width: 200px;
      justify-content: flex-end;
      .arrow {
        width: 32px;
        height: 32px;
        margin-left: 8px;
      }
    }
  }
  .item {
    margin-top: 24px;
    flex-direction: column;
    align-items: flex-start;
    .title {
      font-size: 32px;
      color: #000000;
      line-height: 54px;
    }
    .subtitle {
      font-size: 26px;
      color: #999999;
    }
  }
  .empty {
    font-size: 28px;
    text-align: center;
    color: #999999;
    line-height: 200px;
  }

}
</style>
